module.exports = __webpack_public_path__ + "media/img/frontend_application/footericon/telegram-f1c51ac12fbf93fb1c1f054c7791d0e4.svg";